import { genericPlayerParser } from '../commonInbounds/utils/genericPlayerInboundUtils';
import { inboundPlayerServerSettingsParser } from '../commonInbounds/utils/playerServerSettingsInboundUtils';
import { inboundSelfDataParser } from '../commonInbounds/utils/selfDataInboundUtils';
import { booleanParser, createArrayWithBracesParser, encodedStringParser, numberParser, stringParser } from '../inboundParsers';
import { mttStagingTableParser } from './utils/mttStagingTableInboundUtils';
export const MTT_STAGING_INIT_DATA_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'inboundSelfData', parser: inboundSelfDataParser },
        { name: 'players', parser: createArrayWithBracesParser(genericPlayerParser) },
        { name: 'salePercentMore', parser: numberParser },
        { name: 'isMttStagingRoom', parser: booleanParser },
        { name: 'isMttChipUpAllowed', parser: booleanParser },
        { name: 'bonusMttStartingChipsPercentForPowerPlayer', parser: numberParser },
        { name: 'isMttSponsorAvailable', parser: booleanParser },
        { name: 'areMttStagingControlsActive', parser: booleanParser },
        { name: 'mttIconLabel', parser: encodedStringParser },
        { name: 'sessionId', parser: stringParser },
        { name: 'canBeNinja', parser: booleanParser },
        { name: 'isNinja', parser: booleanParser },
        { name: 'isOwner', parser: booleanParser },
        { name: 'isMttReady', parser: booleanParser },
        { name: 'numMttJacksSponsored', parser: numberParser },
        { name: 'mttStagingTables', parser: createArrayWithBracesParser(mttStagingTableParser) },
        { name: 'mttSettingsHtml', parser: encodedStringParser },
        { name: 'autoMttConstantInfoString', parser: stringParser },
        { name: 'autoMttSponsorString', parser: stringParser },
        { name: 'gameName', parser: encodedStringParser },
        { name: 'roomId', parser: numberParser },
        { name: 'infoMarkdown', parser: encodedStringParser },
        { name: 'autoMttTimerSecondsRemaining', parser: numberParser },
        { name: 'inboundPlayerServerSettings', parser: inboundPlayerServerSettingsParser }
    ]
};
